import { divIcon } from 'leaflet';
import { MARKER_BLUE, MARKER_RED, markerSvgHtml } from './constants';

interface MarkerProps {
  redMarker?: boolean;
}

const blueIcon = divIcon({
  className: '',
  iconSize: [38, 38],
  iconAnchor: [19, 38],
  popupAnchor: [0, -34],
  html: markerSvgHtml(MARKER_BLUE)
});

const redIcon = divIcon({
  className: '',
  iconSize: [38, 38],
  iconAnchor: [19, 38],
  popupAnchor: [0, -34],
  html: markerSvgHtml(MARKER_RED)
});

export const getNoddiLeafletIcon = (props?: MarkerProps) => (props?.redMarker ? redIcon : blueIcon);
